export default __webpack_public_path__ + "static/media/boladetransferencia.4939b966.png";